export default "/images/vendor/flag-icon-css/flags/1x1/mz.svg?525b13720883d5b9fdd27d12aad6ff44";